const filterButtons = document.querySelectorAll(".filter-btn");
const galleryItems = document.querySelectorAll(".gallery-item");
const loadMoreBtn = document.getElementById("loadMore");

let itemsPerPage = 9; // ile elementów pokazać na raz
let currentItems = 0; // licznik widocznych elementów

// funkcja pokazywania elementów
function showItems(filterValue = "all") {
  let visibleCount = 0;

  galleryItems.forEach((item, index) => {
    const matchesFilter = filterValue === "all" || item.classList.contains(filterValue);

    if (matchesFilter && visibleCount < currentItems) {
      item.classList.remove("hidden");
      visibleCount++;
    } else {
      item.classList.add("hidden");
    }
  });

  // sprawdź, czy są jeszcze elementy do załadowania
  const totalVisible = [...galleryItems].filter(item =>
    filterValue === "all" ? true : item.classList.contains(filterValue)
  ).length;

  if (currentItems >= totalVisible) {
    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = "Koniec galerii";
  } else {
    loadMoreBtn.disabled = false;
    loadMoreBtn.textContent = "Pokaż więcej zdjęć";
  }
}

// obsługa kliknięć w filtry
filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    filterButtons.forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");

    currentItems = itemsPerPage; // reset przy zmianie filtra
    showItems(button.dataset.filter);
  });
});

// obsługa przycisku "Load more"
loadMoreBtn.addEventListener("click", () => {
  currentItems += itemsPerPage;
  const activeFilter = document.querySelector(".filter-btn.active").dataset.filter;
  showItems(activeFilter);
});

// początkowe wyświetlenie
currentItems = itemsPerPage;
showItems("all");